import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-upload',
	templateUrl: './upload.component.html',
	styleUrls: ['./upload.component.css'],
	standalone: false,
})
export class UploadComponent {
	constructor(public router: Router) {}

	public navigateToDocumentsUploadStep1(): void {
		this.router.navigate(['/private/files-upload/upload/documents/step1']);
	}
}
